import { defineComponent as _defineComponent } from 'vue'
import { useI18n } from '@/composables/i18n';
import { DeviceView } from '@/views/careConsole/commons/navigation';
import { computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'DeviceViewSwitch',
  props: {
    value: null
  },
  emits: ["input"],
  setup(__props: any, { emit }: { emit: ((e: 'input', value: DeviceView) => void), expose: any, slots: any, attrs: any }) {

const props = __props as { value: DeviceView };





const { t } = useI18n();

const selectedValue = computed({
  get() {
    return props.value;
  },
  set(newValue) {
    emit('input', newValue);
  },
});

return { __sfc: true,props, emit, t, selectedValue, DeviceView }
}

})